let loading = null;

// Carica una sola volta il Facebook JS SDK (serve per «Collega WhatsApp»).
export const loadFacebookSdk = (appId, version) => {
  const init = () => window.FB.init({ appId, cookie: true, xfbml: false, version });
  if (window.FB) { init(); return Promise.resolve(window.FB); }
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      window.fbAsyncInit = () => { init(); resolve(window.FB); };
      const s = document.createElement("script");
      s.src = "https://connect.facebook.net/it_IT/sdk.js";
      s.async = true; s.defer = true; s.crossOrigin = "anonymous";
      s.onerror = () => { loading = null; reject(new Error("sdk")); };
      document.body.appendChild(s);
    });
  }
  return loading;
};

export const listenSignup = (onSession) => {
  const handler = (event) => {
    if (!/^https:\/\/(www|web)\.facebook\.com$/.test(event.origin)) return;
    let data = event.data;
    try { data = typeof data === "string" ? JSON.parse(data) : data; } catch { return; }
    if (data?.type === "WA_EMBEDDED_SIGNUP") onSession(data);
  };
  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
};
